<template lang="pug">
  .eventActivity
    .container
      .d-flex.align-items-center.justify-content-center
        div(style="letter-spacing: 5px; font-weight: bold; font-size: 1.2rem; margin-bottom: 5px;") 修改預約
      .d-flex.align-items-center.justify-content-center(style="flex-direction: column;")
        input.inputStyle(
        type='text', placeholder="請輸入姓名" v-model='userInfo.name')
        input.inputStyle(
        type='text', placeholder="請輸入行動電話" v-model='userInfo.mobile')
      .multiselect_custom_homePage
        multiselect(
          track-by="activity_start_at",
          label="activity_start_at",
          placeholder="請選擇活動日期",
          :options="storeTimeListFilter",
          :searchable="false",
          :allow-empty="false",
          v-model="userInfo.selectedDate",
          selectLabel='',
          deselect-label='',
          @input='getStoreActivitySession'
          noOptions="無可選擇日期"
        )
          template(slot="noOptions")
            strong 無可選擇日期
      .multiselect_custom_homePage
        multiselect(
          track-by="id",
          label="period_limit",
          placeholder="請選擇活動時段",
          :options="activitySessionList",
          :searchable="false",
          :allow-empty="false",
          v-model="userInfo.selectedTime",
          selectLabel='',
          deselect-label='',
          noOptions="無可選擇時段"
        )
          template(slot="noOptions")
            strong 無可選擇時段
      textarea.inputStyle.textareaStyle.d-flex.align-items-center.justify-content-center(
      type='text', placeholder="請輸入備註" v-model='userInfo.remark', style="margin: 5px 0;")
    .line
    .container
      button.btn.btn-primary.mt-4.mb-3(type="button", @click="goItemList()", style="width: 100%;")
        span(style="margin-right: 10px;") 送出

</template>

<script>
import { mapState } from 'vuex';
const _ = require('lodash');
import { M_EVENT_ACTIVITY_INDEX } from '@/router/member/event-activity';
const moment = require('moment');

  export default {

// 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'event-activity-member-edit',
  props: {
    id: [String, Number]
  },
  data() {
    return {
      couponList: [],
      testStoreOptions: [{ id: 1, store: '台北101店' }, { id: 2, store: '台中遠百店' }],
      actInfo: {
        title: '活動主題活動主題',
        content: '活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明',
        actImg: 'https://images.chinatimes.com/newsphoto/2017-03-17/1024/20170317005512.jpg',
        hint: ['1. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。', '2. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。', '3. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。'],
        actDateList: ['2021/12/01', '2021/12/02', '2021/12/03'],
        actDateTimeList: ['11:00', '14:00', '17:00']
      },
      userInfo: {},
      agreeUseRule: [],
      activitySessionList: [],
      isSend: false,
    };
  },
  methods: {
    moment(val) {
      return moment(val);
    },
    goItemList() {
      const vm = this;
      const MobileReg = /^(09)[0-9]{8}$/;
      if (!vm.userInfo.name) {
        vm.$swal.fire({
          title: '請輸入姓名',
          icon: 'info'
        });
      } else if (!vm.userInfo.mobile) {
        vm.$swal.fire({
          title: '請輸入行動電話',
          icon: 'info'
        });
      } else if (!MobileReg.test(vm.userInfo.mobile)) {
        vm.$swal.fire({
          title: '行動電話格式錯誤',
          icon: 'info'
        });
      } else if (!vm.userInfo.selectedTime) {
        vm.$swal.fire({
          title: '請選擇活動時段',
          icon: 'info'
        });
      } else {
        if (vm.isSend) return;
        vm.isSend = true;

        vm.$swal.fire({
          title: '資料送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        const data = {
          activity_reserve_detail_id: vm.userInfo.selectedTime.id,
          meta: {
            name: vm.userInfo.name,
            mobile: vm.userInfo.mobile
          },
          user_note: vm.userInfo.remark ? vm.userInfo.remark : '',
          id: vm.id
        };

        vm.$store.dispatch('member_event_activity/updateEventActivityHandler', data).then(() => {
          vm.$swal.close();

          vm.isSend = false;
          vm.$router.push({ name: M_EVENT_ACTIVITY_INDEX });
        }).catch(() => {
          vm.isSend = false;
        });
      }
    },
    getStoreActivityTimeList(val) {
      const vm = this;
      vm.$set(vm.userInfo, 'selectedDate', null);
      vm.$set(vm.userInfo, 'selectedTime', null);
      vm.$store.commit('member_event_activity/setActivityTimeList', []);
      vm.$set(vm, 'activitySessionList', []);
      this.$nextTick(() => {
        vm.$swal.fire({
          title: '取得日期時段中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });
        vm.$store.dispatch('member_event_activity/getStoreTimeListHandler', val.pivot.id).then(() => {
          vm.$swal.close();
        });
      });
    },
    getStoreActivitySession(val) {
      const vm = this;
      vm.$set(vm.userInfo, 'selectedTime', null);
      vm.$set(vm, 'activitySessionList', []);
      vm.activitySessionList = val.activity_detail;
    },
  },
  watch: {
    'userInfo.mobile': function (val) {
      this.userInfo.mobile = String(val).replace(/[^0-9]+$/, '');
    }
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    // 清除活動日期
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('member_event_activity/setStoreTimeList', []);
    vm.$store.dispatch('member_event_activity/getEventActivityEditDataHandler', vm.id).then(() => {
      vm.userInfo.name = vm.editData.meta.name;
      vm.userInfo.mobile = vm.editData.meta.mobile;
      vm.userInfo.remark = vm.editData.user_note;
      vm.$store.dispatch('member_event_activity/getStoreTimeListHandler', vm.editData.details.activity_reserve_store_id).then(() => {
        const dateKey = _.findKey(vm.storeTimeList, (val) => val.activity_start_at === vm.editData.reserve_date);
        vm.$set(vm.userInfo, 'selectedDate', vm.storeTimeList[dateKey]);
        vm.$set(vm, 'activitySessionList', vm.storeTimeList[dateKey].activity_detail)
        const timeKey = _.findKey(vm.activitySessionList, (val) => val.activity_start_time === vm.editData.details.activity_start_time && val.activity_end_time === vm.editData.details.activity_end_time);
        vm.$set(vm.userInfo, 'selectedTime',  vm.activitySessionList[timeKey]);
        vm.$swal.close();
      });
    });
    // 正式串接時這個這個要放到取得 actInfo 之後的 .then
    for (let i = 0; i < this.actInfo.hint.length; i++) {
      this.agreeUseRule.push(false);
    }

  },
  computed: {
    ...mapState({
      eventActivity: (state) => state.member_event_activity.eventActivity,
      storeTimeList: (state) => state.member_event_activity.storeTimeList,
      editData: (state) => state.member_event_activity.editData
    }),
    storeTimeListFilter() {
      const vm = this;
      // 如果今日的時候都過期就移除今日的選項
      if (vm.storeTimeList && vm.storeTimeList.length > 0 && vm.storeTimeList[0].activity_start_at === moment().format('YYYY-MM-DD')) {
        if (_.filter(vm.storeTimeList[0].activity_detail, (val) => moment(val.activity_start_at).isBefore(moment()))) {
          // return _.clone(vm.storeTimeList);
          const newArr = _.clone(vm.storeTimeList);
          newArr.splice(0, 1);
          return newArr;
        }
      }
      return vm.storeTimeList;
    }
  }
};
</script>
<style lang="scss" scoped>
.line {
  border-top: solid 1px #aaa;
  width: 100%;
  height: 1px;
}

.container {
  padding: 35px 20px;
  text-align: left;
}

.inputStyle {
  width: 100%;
  padding: 15px;
  text-align: center;
  margin: 5px;
  border: none;
  background: #eee;
}
.footer {
  border-top: solid #aaa 1px;
  padding: 20px;
}
.multiselect_custom_homePage {
  padding: 5px 0;
  & .multiselect__placeholder {
    color: #828282;
    margin-left: 20px;
    font-size: 1rem;
  }
  & .multiselect__tags {
    border: solid #888 1px;
    border-radius: 3px;
    min-height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & .multiselect__input, .multiselect__single {
    text-align: center;
  }
  & .multiselect__select {
    top: 9px;
  }
  & .multiselect__content-wrapper {
    text-align: center;
  }
}
textarea:hover, input:hover, textarea:active, input:active, textarea:focus, input:focus, button:focus, button:active, button:hover, label:focus, .btn:active, .btn.active {
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
}
</style>
